import { useEffect, useState } from 'react'

interface VisualViewport {
  height: number
  offsetTop: number
}

const getVisualViewport = (): VisualViewport => ({
  height: window.visualViewport?.height || 0,
  offsetTop: window.visualViewport?.offsetTop || 0,
})

export const useVisualViewport = () => {
  const [visualViewport, setVisualViewport] = useState<VisualViewport>(getVisualViewport())

  useEffect(() => {
    let animationFrameId: number | undefined

    const updateVisualViewport = () => {
      if (animationFrameId !== undefined) return

      animationFrameId = window.requestAnimationFrame(() => {
        animationFrameId = undefined
        const nextViewport = getVisualViewport()
        setVisualViewport(currentViewport =>
          currentViewport.height === nextViewport.height && currentViewport.offsetTop === nextViewport.offsetTop
            ? currentViewport
            : nextViewport,
        )
      })
    }
    window.visualViewport?.addEventListener('resize', updateVisualViewport)
    window.visualViewport?.addEventListener('scroll', updateVisualViewport)

    return () => {
      window.visualViewport?.removeEventListener('resize', updateVisualViewport)
      window.visualViewport?.removeEventListener('scroll', updateVisualViewport)
      if (animationFrameId !== undefined) window.cancelAnimationFrame(animationFrameId)
    }
  }, [])

  return { visualViewport }
}
